export interface NestedObject {
  [key: string]: number | string | boolean | object | NestedObject;
}

export enum Modes {
  PUBLIC = 'public',
  PRIVATE = 'private',
}
